import { get, remove, set } from 'lib/storage/expirableLocalStorage'

const STORAGE_KEY = 'emailVerificationReturnPath'
// Verification links are usually clicked within a day; after that, fall back to the default redirect.
const TTL_SECONDS = 60 * 60 * 24

/**
 * Remembers a region-less path (e.g. `/societe/my-campaign`) to return to once the
 * customer verifies their email. Stored in localStorage because the verification link
 * is often opened in a new tab.
 */
export function setEmailVerificationReturnPath(path: string) {
  set(STORAGE_KEY, path, TTL_SECONDS)
}

/** Returns and clears the stored return path, if any. */
export function consumeEmailVerificationReturnPath(): string | undefined {
  const path = get<string>(STORAGE_KEY)
  remove(STORAGE_KEY)
  // Only allow same-site relative paths
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') ? path : undefined
}
